// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__37Pfm","footer":"ChangeClinic_footer__3nKgS"};